/**
 * Motor genérico dos catálogos de colunas das telas de consulta.
 *
 * Cada tela declara apenas a lista de colunas (`value`, `text`, `padrao`, `sortable`, `fixa`) e
 * recebe daqui as funções que o grid, o configurador de colunas e as predefinições consomem. O
 * objeto devolvido é o que se passa como `:catalogo` para o `ColunasMenu`.
 *
 * `padrao` define o que aparece para quem nunca configurou nada; `fixa` marca a coluna que não
 * pode ser escondida (a que identifica a linha).
 */
export function criarCatalogoColunas(COLUNAS) {
    const CHAVES_VALIDAS = COLUNAS.map(c => c.value);

    function colunasPadrao() {
        return COLUNAS.filter(c => c.padrao).map(c => c.value);
    }

    function coluna(value) {
        return COLUNAS.find(c => c.value === value);
    }

    /**
     * Descarta chaves que saíram do catálogo (predefinição antiga) e garante que as colunas fixas
     * continuem presentes, para a linha nunca ficar sem identificação.
     */
    function normalizarColunas(valores) {
        const lista = (Array.isArray(valores) ? valores : []).filter(v => CHAVES_VALIDAS.includes(v));

        if (!lista.length) {
            return colunasPadrao();
        }

        COLUNAS.filter(c => c.fixa).forEach(c => {
            if (!lista.includes(c.value)) {
                lista.unshift(c.value);
            }
        });

        return lista;
    }

    return {
        COLUNAS,
        CHAVES_VALIDAS,
        colunasPadrao,
        coluna,
        normalizarColunas,
    };
}
